/**
 * API communication functions for the chatbot widget
 */

/**
 * Sends a message to the chatbot API
 * @param {string} apiUrl - The API URL (optional, defaults to configured URL)
 * @param {string} message - The user message
 * @param {string} domain - The domain (required)
 * @param {string} email - The email (required)
 * @param {Array} conversationHistory - Previous messages in the conversation
 * @returns {Promise<Object>} The API response
 */


export async function sendMessage(apiUrl, message, domain, email, type, conversationHistory = []) {
    try {
        const response = await fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: message,
                domain: domain,
                email: email,
                type: type
            })
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`API error (${response.status}): ${errorText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error sending message to API:', error);
        throw error;
    }
}

export async function sendTicketInfo(data) {
    try {
        //   const response = await fetch('https://stagesupportdesk.jsimple.com/Support/CreateTicket', {
        const response = await fetch('/api/ChatBot/CreateTicket', {
            method: 'POST',
            headers: {
                'X-CLIENT-TYPE': 'chatbot'   // ✅ NOT a secret
                // DO NOT set Content-Type when using FormData
            },
            // headers: {
            //     'Content-Type': 'application/json',
            // },
            body: data
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`API error (${response.status}): ${errorText}`);
        }

        const responseData = await response.json();

        return responseData.ticketId; // ✅ only return the number
    } catch (error) {
        console.error('Error sending ticket:', error);
        throw error;
    }
}

export async function GetCategories(id) {
    try {
        // const response = await fetch('https://stagesupportdesk.jsimple.com/api/Support/GetCategories', {
        const response = await fetch('/api/ChatBot/GetCategories', {
            method: 'POST',
            
            headers: {
                'Content-Type': 'application/json',
                   'X-CLIENT-TYPE': 'chatbot'   // ✅ NOT a secret
            },
            //body: JSON.stringify(id)

            body: JSON.stringify({ id: id })  // Send as object: { "id": 5 }
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`API error (${response.status}): ${errorText}`);
        }

        const responseData = await response.json();

        // ✅ Return full category list, not a ticketId
        return responseData;
    } catch (error) {
        console.error('Error loading categories:', error);
        throw error;
    }
}


export async function GetClientSetupInfo(clientId) {
    try {
        // const response = await fetch('/Support/GetClientSetupInfo', {
        // const response = await fetch('http://localhost:64785/api/ChatBot/GetClientSetupInfo', {
        const response = await fetch('/api/ChatBot/GetClientSetupInfo', {
            method: 'POST', // Only works if your controller uses [HttpPost]
            headers: {
                'Content-Type': 'application/json',
                    'X-CLIENT-TYPE': 'chatbot'   // ✅ NOT a secret
            },
            body: JSON.stringify({ id: clientId }) // ✅ key should match DTO property name
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`API error (${response.status}): ${errorText}`);
        }

        // ✅ Parse response data if needed
        const data = await response.json();
        return data;

    } catch (error) {
        console.error('Error loading client setup info:', error);
        throw error;
    }
}

export async function sendVerificationOtp(userName, contactInfo, isEmail) {
    try {

        // const response = await fetch('https://stagesupportdesk.jsimple.com/api/ChatBot/sendVerificationOtp', {

        const response = await fetch('/api/ChatBot/sendVerificationOtp', {
            method: 'POST', // Only works if your controller uses [HttpPost]
            headers: {
                'Content-Type': 'application/json',
                'X-CLIENT-TYPE': 'chatbot'   // ✅ NOT a secret 
            },
            body: JSON.stringify({ userName, contactInfo, isEmail }) // ✅ key should match DTO property namec
        });
        const result = await response.json();
        // console.log(result);
        return result;

    } catch (error) {
        console.error('Error in sendVerificationOtp', error);
        throw error;
    }
}

export async function createChatUser(userName, contactInfo, isEmail, clientId) {
    try {

        // const response = await fetch('https://stagesupportdesk.jsimple.com/api/ChatBot/createChatUser', {
            const response = await fetch('/api/ChatBot/createChatUser', {
            method: 'POST', // Only works if your controller uses [HttpPost]
            headers: {
                'Content-Type': 'application/json',
                'X-CLIENT-TYPE': 'chatbot'   // ✅ NOT a secret
            },
            body: JSON.stringify({ userName, contactInfo, isEmail, clientId }) // ✅ key should match DTO property namec
        });
        const result = await response.json();
        // console.log(result);
        return result;

    } catch (error) {
        console.error('Error in sendVerificationOtp', error);
        throw error;
    }
}

export async function getPromtResult(message) {
    try {
        const response = await fetch('https://lambda.jsimple.com/analyse/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ prompt: message })
        });

        if (!response.ok) {
            const errorText = await response.text();
            console.log(`API error (${response.status}): ${errorText}`);
            throw new Error(`API error (${response.status}): ${errorText}`);
        }

        const result = await response.json();
        const raw = result.response;
        console.log("RAW content from API:\n", raw);

        const jsonMatch = raw.match(/\{[\s\S]*\}/);
        const clean = jsonMatch ? jsonMatch[0] : raw;

        return JSON.parse(clean.trim());

    } catch (error) {
        console.error('Error sending message to API:', error);
        throw error;
    }
}
export async function GetAllActiveCategories() {
    try {
        // const response = await fetch('https://stagesupportdesk.jsimple.com/api/ChatBot/GetAllActiveCategories', {
        const response = await fetch('/api/ChatBot/GetAllActiveCategories', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
               'X-CLIENT-TYPE': 'chatbot'   // ✅ NOT a secret
        }
    });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`API error (${response.status}): ${errorText}`);
        }

        const responseData = await response.json();

        // ✅ Log the returned data, not the Response object
        console.log("Received Categories:", responseData);

        return responseData;
    } catch (error) {
        console.error('Error loading categories:', error);
        throw error;
    }
}
